import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import Link from "next/link";
import type { ReactElement } from "react";

import {
  cityReportFaq,
  faqHeading,
  type CityFaqInput,
  type FaqSegment,
} from "@/lib/destinations/city-report-copy";

function FaqAnswer({ segments }: { segments: readonly FaqSegment[] }): ReactElement {
  return (
    <Text
      fontSize={{ base: "15px", md: "16px" }}
      lineHeight="1.6"
      color="var(--color-text-secondary)"
    >
      {segments.map((segment, index) =>
        segment.href ? (
          <Link key={`${segment.href}-${index}`} href={segment.href}>
            <Text
              as="span"
              color="var(--color-primary)"
              _hover={{ textDecoration: "underline" }}
            >
              {segment.text}
            </Text>
          </Link>
        ) : (
          <Text as="span" key={`${segment.text}-${index}`}>
            {segment.text}
          </Text>
        ),
      )}
    </Text>
  );
}

export function CityReportFaq(input: CityFaqInput): ReactElement {
  const items = cityReportFaq(input);

  return (
    <Box as="section">
      <Heading
        as="h2"
        fontFamily="var(--font-display)"
        fontSize={{ base: "20px", md: "22px" }}
        fontWeight="600"
        letterSpacing="-0.02em"
        color="var(--color-text-primary)"
        mb={4}
      >
        {faqHeading(input.city)}
      </Heading>
      <Stack gap={0} maxW="68ch">
        {items.map((item) => (
          <Box
            key={item.question}
            py={3}
            borderBottom="1px solid var(--color-border-subtle)"
          >
            <Text
              as="h3"
              fontSize="15px"
              fontWeight="600"
              color="var(--color-text-primary)"
              mb={1}
            >
              {item.question}
            </Text>
            <FaqAnswer segments={item.segments} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
